import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=75571c42&scoped=true"
import script from "./Polygon.vue?vue&type=script&lang=js"
export * from "./Polygon.vue?vue&type=script&lang=js"
import style0 from "./Polygon.vue?vue&type=style&index=0&id=75571c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75571c42",
  null
  
)

export default component.exports